/**
 * 动态加载字体的简单工具函数
 */

/**
 * 加载自定义字体到页面
 * @param fontUrl 字体文件URL
 * @param fontName 字体名称
 */
export const loadCustomFont = (fontUrl: string, fontName: string) => {
  // 检查是否已经添加过相同的字体
  const existingStyle = document.getElementById(`font-${fontName}`);
  if (existingStyle) {
    return; // 字体已加载，无需重复加载
  }

  // 创建 @font-face 规则
  const style = document.createElement('style');
  style.id = `font-${fontName}`;
  style.textContent = `
    @font-face {
      font-family: '${fontName}';
      src: url('${fontUrl}') format('truetype'),
           url('${fontUrl}') format('opentype'),
           url('${fontUrl}') format('woff'),
           url('${fontUrl}') format('woff2');
      font-display: swap;
    }
  `;

  document.head.appendChild(style);
};